/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { createIndexedDBSuperstore, createAsyncLocalSuperstore } from 'superstore';
let storeInstance;
let localStoreInstance;
export function getLocalStore() {
  if (!localStoreInstance) {
    localStoreInstance = createAsyncLocalSuperstore({
      namespace: 'framework-listing-lib'
    });
  }
  return localStoreInstance;
}
const getStoreInstance = () => {
  if (!storeInstance) {
    storeInstance = createIndexedDBSuperstore({
      namespace: 'framework-listing-lib'
    }).open();
  }
  return storeInstance;
};
export function getSuperStoreValue(key) {
  return getStoreInstance().then(store => store.get(key));
}
export function setSuperstoreValue(key, value) {
  return getStoreInstance().then(store => store.set(key, value));
}
export function wipeSuperstore() {
  return Promise.all([getStoreInstance().then(store => store.clear()), getLocalStore().clear()]);
}